import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=623f0607&scoped=true&class=h-full&"
import script from "./OrderForm.vue?vue&type=script&lang=js&"
export * from "./OrderForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderForm.vue?vue&type=style&index=0&id=623f0607&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f0607",
  null
  
)

export default component.exports